<template>
  <div class="vertical-align-comp">
    <!-- <MDBInput
          label="Vartical Align"
          type="number"
          @change="ChangeVarticalAlignChar()"
        /> -->
        <div class="design-align-container">
          <div v-if="saveProg==true" style="color: red;">Saving in progress - please wait</div>
          <div class="btn btn-secondary"
            style="color: red;"
            @click="saveChanges()"
            >Click Here To Save Your Work!!
          </div>
          <div>
<div class="btn btn-secondary"
            @click="cancleSelected()"
            >Cancle Selected Chars
          </div>
          <div class="btn btn-secondary"
            @click="selectAllChars()"
            >Select All Chars
          </div>
          </div>
          <div class="border"><label>Change Vertical Align To All Selected Chars</label>
          <span class="align-btns">
          <span title="Up" @click="ChangeVartical('down')">
          <img :src="store.baseIconsURL + '//Icons-CloseIconBlack.png'" style="height: 10px" />
        </span>
        <span title="Down" @click="ChangeVartical('up')">
          <img :src="store.baseIconsURL + '//Icons-OpenIconBlack.png'" style="height: 10px" />
        </span>
        </span>
          <!-- <MDBInput
          label="Vartical Align"
          type="number"
          v-model="addAlign"
          @change="ChangeVarticalAlignChar()"
        /> -->
        </div>
    <div class="align-div border">
      <label style="margin-right: 15px; font-size: 16px">Align</label>
      <div style="display: flex; gap: 10px">
        <div
          :class="align == 'bottom' ? 'active-align' : 'align-option'"
          title="align bottom"
        >
          <icon-svg
            icon="carbon:align-vertical-bottom"
            @click="changeAlign('bottom')"
            :height="25"
            :width="25"
            style="cursor: pointer"
            :style="{
              margin: '3px',
              color: align == 'bottom' ? '#72984F' : 'rgba(88, 89, 91, 1)',
            }"
          />
        </div>
        <div
          :class="align == 'center' ? 'active-align' : 'align-option'"
          title="align center"
        >
          <icon-svg
            icon="carbon:align-vertical-center"
            @click="changeAlign('center')"
            :height="25"
            :width="25"
            style="cursor: pointer"
            :style="{
              margin: '3px',
              color: align == 'center' ? '#72984F' : 'rgba(88, 89, 91, 1)',
            }"
          />
        </div>
        <div
          :class="align == 'top' ? 'active-align' : 'align-option'"
          title="align top"
        >
          <icon-svg
            icon="carbon:align-vertical-top"
            @click="changeAlign('top')"
            :height="25"
            :width="25"
            style="cursor: pointer"
            :style="{
              margin: '3px',
              color: align == 'top' ? '#72984F' : 'rgba(88, 89, 91, 1)',
            }"
          />
        </div>
      </div>
    </div>
        </div>
    <div class="chars-container">
      <div
        v-for="(charactarObject, index) in charsList"
        :key="index"
        class="char-layer"
        @click="selectChar(charactarObject, index)"
      >
        <div style="display: grid">
          <div
            class="targetRight"
            :style="{
              position: 'absolute'
            }" :datay="charactarObject.y"
          >
            <DSTPreview
              :dwidth="
                charactarObject.charFile.dstfile.pixelWidth * (dpi / 254.0)
              "
              :dheight="
                charactarObject.charFile.dstfile.pixelHeight * (dpi / 254.0)
              "
              :dstFile="charactarObject.charFile.dstfile"
              :layersColors="[charactarObject.colorID]"
              :left="getLeft(index, charactarObject) * (dpi / 254.0)"
              :top="charactarObject.y * (dpi / 254.0)"
              :transparent="superPos !== 'normal'"
              :arc="charactarObject.arc"
            >
            </DSTPreview>
          </div>
        </div>
      </div>
    </div>
    &nbsp;
  </div>
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import DSTPreview from "./DSTPreview.vue";
// import {
  // MDBInput,
  // MDBBtn,
// } from "mdb-vue-ui-kit";

export default {
  setup() {
    const store = designerStore();
    return {
      store,
    };
  },
  components: {
    DSTPreview,
    // MDBInput,
    // MDBBtn,
  },
  data() {
    return {
      charsList: [], //כל האותיות
      firstCharId: null,
      selectedChars: [],
      // selectedList: [],
      // charsIndexList: [],

      regularColor: null,
      firstColor: null,
      charsColor: null,

      align: "",
      addAlign: 0,

      saveProg: false,
    };
  },
  mounted() {
    this.charsList = this.store.fromTextToCharsObjects(
      this.TextToPreview,
      this.x,
      this.y,
      this.IDFontToPreview,
      this.IDSizeFontToPreview,
      this.layersColors[0].colorID,
      this.arc
    ).listChars;
    // this.charsIndexList = this.charsList.forEach((e,i)=> {return i});
    this.regularColor = Object.values(this.store.getAllColors())[0].colorID;
    this.firstColor = Object.values(this.store.getAllColors())[1].colorID;
    this.charsColor = Object.values(this.store.getAllColors())[3].colorID;
  },
  props: [
    "IDFontToPreview",
    "IDSizeFontToPreview",
    "TextToPreview",
    "dpi",
    "superPos",
    "layersColors",
    "x",
    "y",
    "arc",
  ],

  // normal, alignLeft, alignRight

  methods: {
    getLeft(index, charactarObject) {
      if (this.superPos == "normal") {
        return charactarObject.x;
      } else if (this.superPos == "alignLeft") {
        return 0;
      } else if (this.superPos == "alignRight") {
        const mwidth = [...this.TextToPreview]
          .map(
            (x) =>
              this.store.allFonts.value[this.IDFontToPreview].sizes[
                this.IDSizeFontToPreview
              ].DictCharacters[x].dstfile.pixelWidth
          )
          .reduce((x, y) => (x > y ? x : y));
        return (
          (mwidth -
            this.store.allFonts.value[this.IDFontToPreview].sizes[
              this.IDSizeFontToPreview
            ].DictCharacters[this.TextToPreview[index]].dstfile.pixelWidth) *
          (this.dpi / 254.0)
        );
      }
    },
    OnDrag(e) {
      console.log(
        "save this: ",
        (e.transform.substring(11, e.transform.indexOf("px")) * 254.0) /
          this.dpi
      );
    },
    // createCharsList() {
    //   this.charsList = this.store.fromTextToCharsObjects(this.TextToPreview, this.x, this.y, this.IDFontToPreview, this.IDSizeFontToPreview,this.layersColors[0].colorID, this.arc).listChars;
    //   // this.charsIndexList = this.charsList.forEach((e,i)=> {return i});
    //   this.regularColor = Object.values(this.store.getAllColors())[0].colorID;
    //   this.firstColor = Object.values(this.store.getAllColors())[1].colorID;
    //   this.charsColor = Object.values(this.store.getAllColors())[2].colorID;
    //   return this.charsList;
    // },
    selectChar(charactarObject, index) {
      // console.log("charactarObject = ", charactarObject);
      if (this.firstCharId == index) {
        //אם האות היית הראשונה ונלחצה שוב - מבטל את הבחירה שלה
        this.charsList.find((f) => f.index == index).colorID =
          this.regularColor;
        this.firstCharId = null;
      } else {
        if (this.firstCharId == null) {
          //אם האות הזו הראשונה שנבחרה
          // charactarObject.colorID = this.firstColor;
          this.charsList.find((f) => f.index == index).colorID =
            this.firstColor;
          this.firstCharId = index;
        } else {
          if (
            Object.values(this.selectedChars).findIndex(
              (f) => f.index == index
            ) == -1
          ) {
            //אם האות לא קיימת ברשימת האותיות הבחורות - מוסיף אותה לרשימה
            this.selectedChars.push(charactarObject);
            // this.charsIndexList.push(index);
            this.charsList.find((f) => f.index == index).colorID =
              this.charsColor;
          } else if (
            Object.values(this.selectedChars).findIndex(
              (f) => f.index == index
            ) != -1
          ) {
            //אם האות קיימת כבר ברשימה של האותיות הבחורות - מוחק אותה
            this.selectedChars.splice(
              Object.values(this.selectedChars).findIndex(
                (f) => f.index == index
              ),
              1
            );
            this.charsList.find((f) => f.index == index).colorID =
              this.regularColor;
          }
        }
      }
      // charactarObject.colorID = this.firstChar == null ? this.firstColor :
      //     ((Object.values(this.charsList).findIndex(f => f == charactarObject.colorID)) != -1 ? )

      // if()
      // //מוחק את האות הבחורה מהרשימה אם הלחצה שוב
      // if((Object.values(this.charsList).findIndex(f => f == charactarObject.colorID)) != -1) {
      //     Object.values(this.charsList).splice(Object.values(this.charsList).findIndex(f => f == charactarObject.colorID), 1);
      // }
      //a.splice(3, 1)
    },
    createChars(list) {
      var res = Object.values(list).forEach((e) =>
        res.push({
          charFile: e.charFile,
          colorID: e.colorID,
          x: e.x,
          y: e.y,
          arc: e.arc,
        })
      );
    },
    ChangeVarticalAlignChar() {
      if(this.firstCharId != null) {
        this.charsList.find((f) => f.index == this.firstCharId).y += parseFloat(this.addAlign);
      }
      this.selectedChars.forEach(f => f.y += parseFloat(this.addAlign));
      console.log("ChangeVarticalAlignChar is : ", this.selectedChars);
      console.log("index = ", this.firstCharId);
    },
    ChangeVartical(type) {
      if(type == 'up') {
        if(this.firstCharId != null) {
        this.charsList.find((f) => f.index == this.firstCharId).y += 1;
        }
        this.selectedChars.forEach(f => f.y += 1);
      } else if(type == 'down') {
          if(this.firstCharId != null) {
            this.charsList.find((f) => f.index == this.firstCharId).y -= 1;
          }
          this.selectedChars.forEach(f => f.y -= 1);
      }
    },
    getCurrentChar() {
      return this.charsList.find((f) => f.index == this.firstCharId);
    },
    changeAlign(align) {
      this.align = align;
      if (this.firstCharId != null) {
        var newChar = this.charsList.find((f) => f.index == this.firstCharId);
        if (this.align == "bottom") {
          this.selectedChars.forEach(
            (e) =>
              (e.y = newChar.y + newChar.charFile.height - e.charFile.height)
          );
        } else if (this.align == "top") {
          this.selectedChars.forEach((e) => (e.y = newChar.y));
        } else if (this.align == "center") {
          this.selectedChars.forEach((e) => (e.y = newChar.y - ((e.charFile.height / 2) - (newChar.charFile.height / 2))))
        }
      }
    },
    cancleSelected() {
      this.firstCharId = null;
      this.selectedChars = [];
      this.charsList.forEach(f => f.colorID = this.regularColor);
    },
    selectAllChars() {
      this.firstCharId = 0;
      this.charsList[0].colorID = this.firstColor;
      for (let index = 1; index < this.charsList.length; index++) {
        this.selectedChars.push(this.charsList[index]);
        this.charsList[index].colorID = this.charsColor;
      }
      // this.firstCharId = null;
      // this.charsList.forEach(e => {
      //   e
      // });
      // this.charsList.forEach(f => f.colorID = this.charsColor);
    },
    saveChanges() {
      this.saveProg = true;
      
      //מעדכן את המקומות של הגודל הנוכחי
      this.charsList.forEach(e => 
        this.store.allFonts.value[this.IDFontToPreview].sizes[this.IDSizeFontToPreview].DictCharacters[e.charFile.c].dyAlign = -(e.y)
      );

      //מעתיק את נתוני הגודל הנוכחי עבור כל הגדלים
      var firstAllChars = this.store.allFonts.value[this.IDFontToPreview].sizes[this.IDSizeFontToPreview].DictCharacters;
      var first = Object.values(firstAllChars)[0];
      // var maxAlign = first.dyAlign;
      // var minAlign = first.dyAlign - first.height;

      var firstTop = first.dyAlign; //-50

      Object.values(this.store.allFonts.value[this.IDFontToPreview].sizes).map(m => m.sizeID).forEach(curSize => {
        //this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].DictCharacters
        this.store.fromTextToCharsObjects(
          this.store.getTextToPreview(this.IDFontToPreview, curSize),
          this.x,
          this.y,
          this.IDFontToPreview,
          curSize,
          this.layersColors[0].colorID,
          this.arc
        ).listChars.forEach(e =>
          // this.charsList.forEach(e => 
          this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].DictCharacters[e.charFile.c].dyAlign = -(e.y)
        )
        // var first = Object.values(this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].DictCharacters)[0];
        // var fHeight = 0;
        // var maxAlign = first.dyAlign;
        // var minAlign = first.dyAlign - first.height;

        // var minTop = first.dyAlign;
        var firstCurrentObj = Object.values(this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].DictCharacters)[0];
        var minTop = firstTop * (firstCurrentObj.height / first.height);
        var maxAlign = firstCurrentObj.dyAlign;
        var minAlign = firstCurrentObj.dyAlign - firstCurrentObj.height;
        var fHeight = 0;

        // var maxAlign = first.dyAlign + (first.height / 2);
        // var minAlign = first.dyAlign - (first.height / 2);
        Object.values(this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].DictCharacters).forEach(e => {
          var curDyAlign = firstAllChars[e.c].dyAlign * (e.height / firstAllChars[e.c].height);
          this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].DictCharacters[e.c].dyAlign = curDyAlign;
          minAlign = (e.dyAlign - e.height) < minAlign ? (e.dyAlign - e.height) : minAlign;
          maxAlign = (e.dyAlign) > maxAlign ? (e.dyAlign) : maxAlign;
          minTop = e.dyAlign > minTop ? e.dyAlign : minTop;
          // minAlign = (e.dyAlign - (e.height / 2)) < minAlign ? (e.dyAlign - (e.height / 2)) : minAlign;
          // maxAlign = (e.dyAlign + (e.height / 2)) > maxAlign ? (e.dyAlign + (e.height / 2)) : maxAlign;
        });
        fHeight = (maxAlign - minAlign);
        this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].FontHeight = fHeight;
        // var d = (maxAlign + minAlign) / 2;

        Object.values(this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].DictCharacters).forEach(e => {
          // this.store.allFonts.value[this.IDFontToPreview].sizes[this.IDSizeFontToPreview].DictCharacters[e.c].dyAlign = e.dyAlign - d;
          this.store.allFonts.value[this.IDFontToPreview].sizes[curSize].DictCharacters[e.c].dyAlign = e.dyAlign - minTop;
        });
      });      
      this.saveProg = false;
      document.getElementById("close-vertical-modal-btn").click();
    }
  },
};
</script>

<style scoped>
.char-container {
  position: relative;
}
.char-layer {
  position: absolute;
  top: 0;
  background-size: contain;
  background-repeat: no-repeat;
}
.chars-container {
  position: absolute;
  top: 350px;
  z-index: 10;
}
.align-div {
  display: grid;
  justify-content: center;
  margin: 15px;
}
.design-align-container {
  display: grid;
  justify-content: center;
  /* margin: 20px; */
  gap: 15px;
  position: fixed;
  width: 100%;
}
.align-btns {
  display: grid;
}
.border {
  padding: 10px;
}
</style>
